import { useCallback, useEffect, useRef, useState } from 'react';
import {
  ExpGetCart,
  ExpGetCategoryList,
  ExpSearch,
  ExpSearchAutoSuggest,
  ExpSearchCount,
} from '../api';
import { ExpNavigate } from '../utils/link-parser';
import { getFilteredAccessibleCategoryQuery } from '../utils/customer-group';
import useEmblaCarousel from 'embla-carousel-react';
import { EmblaOptionsType } from 'embla-carousel';
import { deleteCartData } from '@/utils/cartUtils';
import { deleteCart } from '@/shared/service/bc/graphql/cart';
import { snackbar } from '@/utils';

declare let window: any;

const HeaderController = () => {
  const searchInputRef = useRef<HTMLInputElement>(null);
  const basketRef = useRef<HTMLDivElement>(null);
  const searchController = useRef<any>(null);
  const searchCountController = useRef<any>(null);
  const autoSuggestController = useRef<any>(null);
  const searchProductsTimeoutRef = useRef<any>(null);
  const autoSuggesterTimeoutRef = useRef<any>(null);

  const [searchResult, setSearchResult] = useState<any>([]);
  const [showPreview, setShowPreview] = useState<boolean>(false);
  const [searchSuggestion, setSearchSuggestion] = useState([]);
  const [searchText, setSearchText] = useState<string>('');

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [cartQuantity, setCartQuantity] = useState<number>(0);
  const [isOpenCartPreview, setIsOpenCartPreview] = useState<boolean>(false);
  const [cartDetails, setCartDetails] = useState<any>({});
  const [windowWidth, setWindowWidth] = useState<any>(window.innerWidth);
  const [clickedMenuItem, setClickedMenuItem] = useState<number | null>(null);
  const [areAllAccessibleCategoryData, setAreAllAccessibleCategoryData] = useState<{
    areAllAccessible: any;
    pageSlug: any;
    isLoading: boolean;
  }>({
    areAllAccessible: false,
    pageSlug: '',
    isLoading: false,
  });
  const settingsForSlids: EmblaOptionsType = {
    active: true,
    loop: true,
    slidesToScroll: 1,
  };
  const [emblaRef, emblaApi] = useEmblaCarousel(settingsForSlids);

  const scrollPrev = useCallback(() => {
    if (emblaApi) emblaApi.scrollPrev();
  }, [emblaApi]);

  const scrollNext = useCallback(() => {
    if (emblaApi) emblaApi.scrollNext();
  }, [emblaApi]);

  let b2bIframe: any = document.getElementById('b2b-iframe');
  let iframeWindow: any = null;
  let iframeDocument: any = null;

  if (b2bIframe) {
    iframeWindow = b2bIframe.contentWindow;
    iframeDocument = b2bIframe.contentDocument;
  }

  let prevScrollpos = iframeWindow.scrollY;
  const header = iframeDocument.getElementById('header');
  const headerHeight = header?.offsetHeight;
  const scrlOffsetDown = 180;
  const scrlOffsetUp = 100;

  iframeWindow.onscroll = function () {
    const currentScrollPos = iframeWindow.scrollY;
    if (prevScrollpos > currentScrollPos) {
      // Scrolling up
      if (currentScrollPos < scrlOffsetUp) {
        iframeDocument.body.classList.remove('sticky-header');
        iframeDocument.body.style.paddingTop = `0px`;
      }
    } else {
      // Scrolling down
      // eslint-disable-next-line no-lonely-if
      if (currentScrollPos > scrlOffsetDown) {
        iframeDocument.body.style.paddingTop = `${headerHeight}px`;
        iframeDocument.body.classList.add('group/body');
        iframeDocument.body.classList.add('sticky-header');
      } else if (currentScrollPos <= scrlOffsetDown) {
        iframeDocument.body.classList.remove('sticky-header');
        iframeDocument.body.style.paddingTop = `0px`;
      }
    }

    prevScrollpos = currentScrollPos;
  };

  // end of stickey header script.

  const handleHeaderClass = (event: Event) => {
    const targetElement = event.target as Element;
    if (targetElement.closest('#search-icon') !== null) {
      return;
    }
    const targetElement1 = event.target as Element;
    if (targetElement1 && targetElement1.closest('.header-search-section') === null) {
      // document.body.classList.remove('search-open');
    }
  };

  const closeSearchPreviewWhenClickOutSide = () => {
    iframeDocument.querySelector('body')?.addEventListener('click', (event: Event) => {
      const targetElement = event.target as Element;
      if (
        targetElement.closest('.search-open-icon') !== null ||
        targetElement.tagName === 'INPUT' ||
        targetElement.closest('.search-result-block')
      ) {
        return;
      }
      const targetElement1 = event.target as Element;
      if (targetElement1 && targetElement1.closest('.search-bar-inner') === null) {
        iframeDocument.body.classList.remove('search-open');
        setShowPreview(false);
      }
    });
  };
  /*
  Handling event listners.
  It manages addEventListner and removeEventListner.
  */
  const eventListeners = (event: 'addEventListener' | 'removeEventListener') => {
    iframeDocument[event]('CART_REFRESH', () => {
      getCart();
    });

    // b2bIframe[event]('LOGIN_SUCCESSFUL', (e: any) => {
    //   checkUserLoggedInStatus(e.detail);
    // });
  };

  // Form here we start initiating all event listeners.
  const initiateEventListeners = () => {
    closeSearchPreviewWhenClickOutSide();
    eventListeners('addEventListener');

    // As body object is possible null so it has to be done manually...
    iframeDocument
      .querySelector('body')
      ?.addEventListener('click', (event: Event) => handleHeaderClass(event));

    return (() => {
      eventListeners('removeEventListener');
      iframeDocument
        .querySelector('body')
        ?.removeEventListener('click', (event: Event) => handleHeaderClass(event));
    })();
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    //  create signal for abort unnecessary search API call
    if (searchController?.current) {
      searchController?.current?.abort();
    }
    searchController.current = new AbortController();

    //  create signal for abort unnecessary searchCount API call
    if (searchCountController?.current) {
      searchCountController?.current?.abort();
    }
    searchCountController.current = new AbortController();

    //  create signal for abort unnecessary AutoSuggest API call
    if (autoSuggestController?.current) {
      autoSuggestController?.current.abort();
    }
    autoSuggestController.current = new AbortController();
    setSearchText(event.target.value);
  };

  const triggerProductSearchEvent = (searchResponse: any) => {
    if (searchResponse?.Data?.items) {
      searchResponse?.Data?.items?.forEach((element: any) => {
        element?.rule_details?.forEach((rule: any) => {
          delete rule?.rule_name;
          rule?.conditions?.forEach((condition: any) => {
            delete condition?.name;
          });
        });
      });
    }

    const skusForAnalyticsRules: any = [];
    searchResponse?.Data?.items?.forEach((item: any) => {
      const tempItem: any = {};
      tempItem.sku = item?.sku_esi;
      tempItem.rules = item?.rule_details;
      skusForAnalyticsRules.push(tempItem);
    });
    // AnalyticsService.trackProductSearched({
    //   search_location: 'quick',
    //   searchTerm: searchText,
    //   noOfResults: searchResponse.Data.total_count,
    //   products_detail: skusForAnalyticsRules,
    //   sku: searchResponse?.Data?.items?.map((elem: any) => elem.sku_esi),
    // });
  };

  const getSearchedProducts = async () => {
    try {
      const fieldsToQuery =
        'sku_esi,images_ej,price_efi,retail_price_ef,custom_url,page_slug_esi,brand_esi,brand_page_slug_esi,calculated_price_efi,sale_price_efi,sku_for_analytics_esli';
      const searchObj: any = {
        body: {
          search_terms: searchText?.trim(),
        },
        skip: 0,
        limit: 10,
        fieldsToQuery,
        sortBy: 'relevance',
      };

      const accessibleCategories = getFilteredAccessibleCategoryQuery();

      if (accessibleCategories) {
        searchObj.body.filter = {
          fq: accessibleCategories,
        };
      }

      const searchPromise = [];
      const searchApiPromise = ExpSearch({
        searchObj,
        signal: searchController?.current?.signal,
      });
      searchPromise.push(searchApiPromise);
      const searchCountApiPromise = ExpSearchCount({
        searchObj,
        signal: searchCountController?.current?.signal,
      });
      searchPromise.push(searchCountApiPromise);
      const [searchResponse, searchCountResponse] = await Promise.all(searchPromise);

      if (searchResponse?.Status === 'success') {
        searchResponse.Data.total_count = searchCountResponse?.Data?.total_count;
      }

      if (searchResponse?.Status === 'success') {
        triggerProductSearchEvent(searchResponse);
        setShowPreview(true);
        setSearchResult(searchResponse?.Data);
      }
      setIsLoading(false);
    } catch (err: any) {
      if (
        err.message === 'AbortError: The user aborted a request.' ||
        err.message === 'AbortError: Fetch is aborted'
      ) {
        setIsLoading(true);
      } else {
        setIsLoading(false);
        console.error(err);
      }
    }
  };

  const getAutoSuggesterData = async () => {
    try {
      const searchObj: any = {
        body: {
          search_term: searchText?.trim(),
        },
      };
      const response = await ExpSearchAutoSuggest({
        searchObj,
        signal: autoSuggestController?.current?.signal,
      });
      if (response?.Status === 'success') {
        setSearchSuggestion(response?.Data?.auto_suggester);
      }
    } catch (err: any) {
      if (
        !(
          err.message === 'AbortError: The user aborted a request.' ||
          err.message === 'AbortError: Fetch is aborted'
        )
      ) {
        console.error(err);
      }
    }
  };

  const handleSubmit = (event: any) => {
    event.preventDefault();
    if (searchResult?.isRedirects && searchResult?.redirectURL) {
      ExpNavigate(searchResult?.redirectURL);
    } else if (searchResult?.total_count > 1) {
      ExpNavigate(`search?q=${searchText}`);
      setSearchText('');
      removeClassToOpenSearch();
    } else if (searchResult?.total_count === 1) {
      ExpNavigate(`${searchResult?.items[0]?.page_slug_esi}?m=search&st=${searchText}&aq=true`);
      setSearchText('');
      removeClassToOpenSearch();
    }
  };

  const openSearchPreview = () => {
    setShowPreview(true);
    if (!searchSuggestion?.length && !searchText) {
      getAutoSuggesterData();
    }
    setIsLoading(false);
  };

  const openCartSlider = async () => {
    // eslint-disable-next-line no-restricted-globals
    const userCartObj = await ExpGetCart();
    await checkCartExpiry(userCartObj);
    if (screen.width < 757) {
      ExpNavigate('cart');
      return;
    } else {
      setIsOpenCartPreview(!isOpenCartPreview);
    }
  };

  const getCartQuantity = (cartObj: any) => {
    let quantity = 0;
    if (cartObj) {
      [
        ...(cartObj?.line_items?.physical_items || []),
        ...(cartObj?.line_items?.custom_items || []),
      ].forEach((elem: any) => {
        quantity += elem.quantity;
      });
    }
    setCartQuantity(quantity);
  };

  const addClassToOpenSearch = () => {
    iframeDocument.body.classList.add('search-open');
    iframeDocument.body.classList.add('group');
    iframeDocument.body.classList.add('fixed');
    iframeDocument.body.classList.add('overflow-hidden');
    iframeDocument.body.classList.add('w-full');
    searchInputRef.current && searchInputRef.current.focus();
    setShowPreview(true);
    if (!searchSuggestion?.length && !searchText) {
      getAutoSuggesterData();
    }
    setIsLoading(false);
  };

  const removeClassToOpenSearch = () => {
    iframeDocument.body.classList.remove('search-open');
    iframeDocument.body.classList.remove('group');
    iframeDocument.body.classList.remove('fixed');
    iframeDocument.body.classList.remove('overflow-hidden');
    iframeDocument.body.classList.remove('w-full');
    setSearchText('');
    setShowPreview(false);
  };

  const addClassToOpenMobileMenu = () => {
    const element: any = iframeDocument.getElementById('hamburger-menu');
    if (iframeDocument.body.classList.contains('mobile-menu-open')) {
      iframeDocument.body.classList.remove('mobile-menu-open');
      iframeDocument.body.classList.remove('group');
      iframeDocument.body.classList.remove('fixed');
      iframeDocument.body.classList.remove('overflow-hidden');
      iframeDocument.body.classList.remove('w-full');
      element?.classList.remove('is-open');
    } else {
      element.classList.add('is-open');
      iframeDocument.body.classList.add('mobile-menu-open');
      iframeDocument.body.classList.add('group');
      iframeDocument.body.classList.add('fixed');
      iframeDocument.body.classList.add('overflow-hidden');
      iframeDocument.body.classList.add('w-full');
    }
  };

  const removeClassToCloseMobileMenu = () => {
    iframeDocument.body.classList.remove('mobile-menu-open');
    iframeDocument.body.classList.remove('group');
    iframeDocument.body.classList.remove('fixed');
    iframeDocument.body.classList.remove('overflow-hidden');
    iframeDocument.body.classList.remove('w-full');
  };

  const handleMyAccountButtonClick = () => {
    ExpNavigate('login/');
  };
  const checkCartExpiry = async (userCartObj: any) => {
    const cartId: any = userCartObj?.id;
    const userDetails = window.__PING_DETAILS__;
    try {
      if (!cartId) {
        return;
      }
      const URL = userDetails?.environmentType.toLowerCase().includes('dev')
        ? `https://dev-productaddrequest.cookandboardman.io/api/v1/cart/metafields/${cartId}`
        : `https://productaddrequest.cookandboardman.io/api/v1/cart/metafields/${cartId}`;
      const response = await fetch(URL, {
        headers: {
          'content-type': 'application/json',
          appaccesskey: '11afb7c2-7381-4a74-ac55-9728ad6205b6',
        },
      });
      const data = await response.json();
      if (data?.Status === 'success') {
        if (data?.Data?.data?.length) {
          const date = data?.Data?.data[0]?.value;
          const expiryDate = date || null; // Will be like "2025-07-15"
          if (!expiryDate) {
            return false;
          }

          try {
            const currentDate = new Date();

            // Parse the expiry date (format: "2025-07-15") and add 1 day
            // Cart expires on the NEXT day after the expiry date
            const cartExpiryDate = new Date(expiryDate);
            cartExpiryDate.setDate(cartExpiryDate.getDate() + 1); // Add 1 day

            // Set time to start of day for accurate comparison
            const currentDateOnly = new Date(
              currentDate.getFullYear(),
              currentDate.getMonth(),
              currentDate.getDate(),
            );
            const expiryDateOnly = new Date(
              cartExpiryDate.getFullYear(),
              cartExpiryDate.getMonth(),
              cartExpiryDate.getDate(),
            );

            if (currentDateOnly >= expiryDateOnly) {
              if (cartId) {
                const deleteQuery: any = deleteCartData(cartId);
                await deleteCart(deleteQuery);
              }
              snackbar.success('Cart has expired. All items have been removed.');
              // toast.success('Cart has expired. All items have been removed.');
              return true;
            }

            return false;
          } catch (error) {
            console.error('Error checking cart expiry:', error);
            return false;
          }
        }
      }
    } catch (err: any) {
      console.error(err);
    }
  };

  const getCart = async () => {
    const userCartObj = await ExpGetCart();
    await checkCartExpiry(userCartObj);
    setCartDetails(userCartObj);
    getCartQuantity(userCartObj);
  };

  useEffect(() => {
    // Clear previous timeouts
    if (searchProductsTimeoutRef.current) {
      clearTimeout(searchProductsTimeoutRef.current);
    }
    if (autoSuggesterTimeoutRef.current) {
      clearTimeout(autoSuggesterTimeoutRef.current);
    }
    if (searchText && searchText.length > 1) {
      setIsLoading(true);
      // Debounce getSearchedProducts with 300ms delay
      searchProductsTimeoutRef.current = setTimeout(() => {
        getSearchedProducts();
      }, 300);

      // Debounce getAutoSuggesterData with 300ms delay
      autoSuggesterTimeoutRef.current = setTimeout(() => {
        getAutoSuggesterData();
      }, 300);
    }
    if (searchText.length === 0) {
      setShowPreview(false);
      setSearchResult([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText]);

  // Cleanup timeouts on component unmount
  useEffect(() => {
    return () => {
      if (searchProductsTimeoutRef.current) {
        clearTimeout(searchProductsTimeoutRef.current);
      }
      if (autoSuggesterTimeoutRef.current) {
        clearTimeout(autoSuggesterTimeoutRef.current);
      }
    };
  }, []);

  const handleLanguageChange = (language: string) => {
    document.dispatchEvent(
      new CustomEvent('LANGUAGE_CHANGE', {
        detail: {
          language,
        },
      }),
    );
  };

  const handleLogout = () => {
    window.dispatchEvent(new Event('LOGOUT_FROM_B2B'));
    window.b2b.utils.user.logout();
    localStorage.removeItem('categories');
    localStorage.removeItem('user-group');
    document.dispatchEvent(new Event('CART_REFRESH'));
    setAreAllAccessibleCategoryData({
      areAllAccessible: false,
      pageSlug: '',
      isLoading: false,
    });
    window.location.href = `${window.location.origin}/login/?logoutFromB2b=true/`;
  };

  const handleResizeMenu = () => {
    if (window.innerWidth >= 1280) {
      document.body.classList.remove('mobile-menu-open');
      document.body.classList.remove('group');
      document.body.classList.remove('fixed');
      document.body.classList.remove('overflow-hidden');
      document.body.classList.remove('w-full');
    }
    setWindowWidth(window.innerWidth);
    const navigation: any = iframeDocument.querySelector('.navigation-block-inner');
    const li: any = navigation.getElementsByTagName('li');
    Array.from(li)?.length &&
      Array.from(li)?.forEach((item: any, i: any) => {
        if (item?.classList?.contains('is-expanded')) {
          const ul = li[i].querySelector('ul');
          if (ul) {
            ul.removeAttribute('style');
          }
          item.classList.remove('is-expanded');
        }
      });
  };
  const checkAccessibleCategory = () => {
    const userDetails = window['__USER_DETAILS__'];
    if (!userDetails?.userInfo?.id) return { isAvailabel: false };
    const type = userDetails?.userInfo.customerGroupDetails?.category_access?.type;

    if (type === 'all') {
      return { isAvailabel: false, userDetails: userDetails, type: 'all' };
    } else {
      if (
        userDetails?.userInfo?.customerGroupDetails &&
        userDetails?.userInfo.customerGroupDetails?.category_access?.categories?.length
      ) {
        return { isAvailabel: true, userDetails: userDetails };
      } else {
        return { isAvailabel: false };
      }
    }
  };
  const getAccessibleCategoryArray = () => {
    const category = checkAccessibleCategory();
    if (category?.type === 'all') return 'all';
    if (!category.isAvailabel) return [];

    if (category.isAvailabel) {
      const accessibleCategories =
        category.userDetails.userInfo.customerGroupDetails.category_access.categories;

      return accessibleCategories;
    }
  };

  // const checkAccessibleCategories = async () => {
  //   const accessibleCategoryArray = getAccessibleCategoryArray();

  //   if (accessibleCategoryArray === 'all') return { areAllAccessible: false, pageSlug: '' };
  //   localStorage.setItem('categories', JSON.stringify(accessibleCategoryArray));
  //   const accessibleCategorySet = new Set(accessibleCategoryArray);

  //   const subCategoryResponse = await ExpGetCategoryList(
  //     `CA-a157d458-879d-4681-8557-1cecaad386ae-${accessibleCategoryArray[0]}-1`,
  //   );

  //   let areAllAccessible;
  //   let pageSlug = null;
  //   if (subCategoryResponse.Data) {
  //     const categories = subCategoryResponse.Data.categories;
  //     areAllAccessible = isAllEntitiesAvailable(categories, accessibleCategorySet);
  //     pageSlug = categories[0]?.page_slug_esi;
  //   }
  //   return { areAllAccessible, pageSlug };
  // };

  const checkAccessibleCategories = async () => {
    setAreAllAccessibleCategoryData({
      areAllAccessible: false,
      pageSlug: '',
      isLoading: true,
    });
    const accessibleCategoryArray = getAccessibleCategoryArray();

    if (accessibleCategoryArray === 'all') return { areAllAccessible: false, pageSlug: '' };
    localStorage.setItem('categories', JSON.stringify(accessibleCategoryArray));
    // Smart category ID detection strategy
    let subCategoryResponse = null;
    let workingCategoryId = null;
    let accessibleCategorySet = new Set(accessibleCategoryArray);
    const DEFAULT_CATEGORY_ID = 'CA-a157d458-879d-4681-8557-1cecaad386ae';
    // Helper function to test a category ID
    const testCategoryId = async (categoryId: number) => {
      try {
        const response = await ExpGetCategoryList(`${DEFAULT_CATEGORY_ID}-${categoryId}-1`);
        if (response?.Status === 'success' && response?.Data?.categories?.length > 0) {
          return { success: true, response, categoryId };
        }
        return { success: false, response: null, categoryId };
      } catch (error) {
        return { success: false, response: null, categoryId };
      }
    };

    // Step 1: Check first ID (index 0)
    const firstIdResult = await testCategoryId(accessibleCategoryArray[0]);

    if (firstIdResult.success) {
      // First ID works, use it directly
      subCategoryResponse = firstIdResult.response;
      workingCategoryId = firstIdResult.categoryId;
    } else {
      // Step 2: First ID doesn't work, use split strategy
      const totalIds = accessibleCategoryArray.length;
      const midPoint = Math.floor(totalIds / 2);

      // Get test IDs: last 2 from first half + first 2 from second half
      const testIds = [
        ...accessibleCategoryArray.slice(Math.max(0, midPoint - 2), midPoint), // Last 2 from first half
        ...accessibleCategoryArray.slice(midPoint, midPoint + 2), // First 2 from second half
      ];
      for (const categoryId of testIds) {
        const result = await testCategoryId(categoryId);
        if (result.success) {
          subCategoryResponse = result.response;
          workingCategoryId = result.categoryId;
          break;
        }
      }
    }
    if (!subCategoryResponse || !workingCategoryId) {
      return { areAllAccessible: false, pageSlug: '' };
    }

    // Slice array from working category ID onwards
    const workingCategoryIndex = accessibleCategoryArray.indexOf(workingCategoryId);
    const slicedCategoryArray = accessibleCategoryArray.slice(workingCategoryIndex);

    // Update accessibleCategorySet with sliced array
    accessibleCategorySet = new Set(slicedCategoryArray);

    let areAllAccessible;
    let pageSlug = null;
    if (subCategoryResponse.Data) {
      const categories = subCategoryResponse.Data.categories;
      areAllAccessible = isAllEntitiesAvailable(categories, accessibleCategorySet);
      if (areAllAccessible && categories.length && categories[0]?.provider_parent_id_esi == 0) {
        areAllAccessible = true;
        pageSlug = categories[0]?.page_slug_esi;
      } else {
        areAllAccessible = false;
        pageSlug = '';
      }
      // pageSlug = categories[0]?.page_slug_esi;
    }
    return { areAllAccessible, pageSlug };
  };

  const isAllEntitiesAvailable = (categoryTree: any[], entityIdSet: any): boolean => {
    const foundEntities = new Set<number>();

    const traverseTree = (tree: any[]) => {
      for (const category of tree) {
        if (entityIdSet.has(Number(category.provider_id_esi))) {
          foundEntities.add(Number(category.provider_id_esi));
        }

        if (category.child && category.child.length > 0) {
          traverseTree(category.child);
        }
      }
    };

    traverseTree(categoryTree);

    return Array.from(entityIdSet).every((id: any) => foundEntities.has(id));
  };

  const navigateToSlug = async () => {
    const userDetails = window['__USER_DETAILS__'];
    if (userDetails?.userInfo?.id) {
      const { areAllAccessible, pageSlug } = await checkAccessibleCategories();
      setAreAllAccessibleCategoryData({ areAllAccessible, pageSlug, isLoading: false });
    }
  };

  useEffect(() => {
    setIsLoading(false);
    setShowPreview(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.href]);

  useEffect(() => {
    initiateEventListeners();
    navigateToSlug();
    // checkUserLoggedInStatus();

    getCart();
    const handlePushstate = () => {
      if (iframeDocument.body.classList.contains('mobile-menu-open')) {
        const element: any = iframeDocument.getElementById('hamburger-menu');
        element?.classList.remove('is-open');
      }
    };
    window.addEventListener('pushstate', handlePushstate);
    window.addEventListener('resize', handleResizeMenu);
    return () => {
      window.removeEventListener('pushstate', handlePushstate);
      window.removeEventListener('resize', handleResizeMenu);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    // userDetails,
    // selectedCurrency,
    isLoading,
    cartQuantity,
    searchText,
    showSearchPreview: showPreview,
    searchResult,
    setSearchText,
    searchSuggestion,
    handleSubmit,
    handleSearchChange,
    handleMyAccountButtonClick,
    addClassToOpenSerch: addClassToOpenSearch,
    removeClassToOpenSerch: removeClassToOpenSearch,
    addClassToOpenMobileMenu,
    removeClassToCloseMobileMenu,
    openCartSlider,
    isOpenCartPreview,
    setIsOpenCartPreview,
    cartDetails,
    handleLogout,
    searchInputRef,
    basketRef,
    openSearchPreview,
    handleLanguageChange,
    emblaRef,
    scrollNext,
    scrollPrev,
    windowWidth,
    clickedMenuItem,
    setClickedMenuItem,
    areAllAccessibleCategoryData,
  };
};

export { HeaderController };
